const namespace = {
  title: "Similar neighborhoods",
  description:
    "Discover neighborhoods similar to this neighborhood and see how they compare in terms of characteristics and amenities.",
  descriptionWithNeighborhood:
    "Discover neighborhoods similar to {{neighborhoodName}} and see how they compare in terms of characteristics and amenities.",
  noData: "Similar neighborhoods are not available for this location.",
  tags: {
    lessAffordable: "Less affordable",
    comparable: "Comparable",
    moreAffordable: "More affordable",
  },
  pagination: {
    previous: "Show less",
    next: "Show more",
  },
} as const;

export default namespace;
